module.exports = __webpack_public_path__ + "img/meals-saved.59d42859.svg";